/*! js-cookie v3.0.5 | MIT */
function a(o) {
  for (var r = 1; r < arguments.length; r++) {
    var d = arguments[r];
    for (var f in d)
      o[f] = d[f];
  }
  return o;
}
var v = {
  read: function(o) {
    return o[0] === '"' && (o = o.slice(1, -1)), o.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(o) {
    return encodeURIComponent(o).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function u(o, r) {
  function d(n, c, e) {
    if (!(typeof document > "u")) {
      e = a({}, r, e), typeof e.expires == "number" && (e.expires = new Date(Date.now() + e.expires * 864e5)), e.expires && (e.expires = e.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var t in e)
        e[t] && (i += "; " + t, e[t] !== !0 && (i += "=" + e[t].split(";")[0]));
      return document.cookie = n + "=" + o.write(c, n) + i;
    }
  }
  function f(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], e = {}, i = 0; i < c.length; i++) {
        var t = c[i].split("="), w = t.slice(1).join("=");
        try {
          var p = decodeURIComponent(t[0]);
          if (e[p] = o.read(w, p), n === p)
            break;
        } catch {
        }
      }
      return n ? e[n] : e;
    }
  }
  return Object.create(
    {
      set: d,
      get: f,
      remove: function(n, c) {
        d(
          n,
          "",
          a({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return u(this.converter, a({}, this.attributes, n));
      },
      withConverter: function(n) {
        return u(a({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(r) },
      converter: { value: Object.freeze(o) }
    }
  );
}
var l = u(v, { path: "/" });
const s = () => typeof window < "u" && typeof window.document < "u", g = () => !s(), h = () => s() && window.location.host.startsWith("beta"), C = () => l.get("IS_CANARY") === "true", I = () => l.get("fondof_internal") === "true", R = () => s() && window.location.host.includes("stage."), m = () => s() && (window.location.host.includes("dev.") || window.location.host.includes("localhost")), x = () => s() && window.location.host.includes("www."), S = {
  isBrowser: s(),
  isSSR: g(),
  isBeta: h(),
  isCanary: C(),
  isInternal: I(),
  isStage: R(),
  isDev: m(),
  isProd: x()
};
export {
  S as env,
  h as isBeta,
  s as isBrowser,
  C as isCanary,
  m as isDev,
  I as isInternal,
  x as isProd,
  g as isSSR,
  R as isStage
};
//# sourceMappingURL=env.js.map
